import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import {
  ErrorMonitoringService,
  NetworkErrorMonitoringEvent,
} from './error-monitoring.service';

@Injectable()
export class GlobalHttpErrorInterceptor implements HttpInterceptor {
  private readonly errorMonitoringService = inject(ErrorMonitoringService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          const event: NetworkErrorMonitoringEvent = {
            source: 'http-interceptor',
            method: request.method,
            url: request.url,
            statusCode: error.status,
            timestamp: new Date().toISOString(),
          };

          this.errorMonitoringService.captureNetworkError(event, error);
        }

        return throwError(() => error);
      }),
    );
  }
}
